import { fromResponse } from '@sales-domain/http-errors';

export async function swrMutationFetcher<TArg, TResponse>(
  url: string,
  { arg }: { arg: TArg },
): Promise<TResponse> {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Correlation-Id': crypto.randomUUID(),
    },
    body: JSON.stringify(arg),
  });
  if (!response.ok) {
    throw fromResponse(response);
  }

  return await response.json();
}

export async function swrQueryFetcher(url: string) {
  const response = await fetch(url);

  if (!response.ok) {
    throw fromResponse(response);
  }

  return await response.json();
}
